// node modules
import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { useQuery, gql } from '@apollo/client';

// app modules: components
import Tabs from 'components/Tabs';

// app modules: constants
import { defaultCollectionsTabs } from 'constants/content';

const COLLECTIONS_GROUPS_QUERY = gql`
  query GetCollectionsGroups($tags: [String]) {
    CollectionsGroups(tags: $tags) {
      id
      title
      href
    }
  }
`;

export default function CollectionsTabs(props) {
  const { selectedTab } = props;
  const user = useSelector(state => state.user);

  const tags = new Set();
  if (user.collection_tags) {
    user.collection_tags.forEach(tag => {
      tags.add(tag);
    });
  }
  if (user.subscription && user.subscription.collection_tags) {
    user.subscription.collection_tags.forEach(tag => {
      tags.add(tag);
    });
  }
  if (user.oven_brands) {
    user.oven_brands.forEach(tag => {
      tags.add(tag.toLowerCase());
    });
  }

  // Send the list of the tabs we are interested in to the API and it will give us a list of tabs to display.
  const { data } = useQuery(COLLECTIONS_GROUPS_QUERY, {
    variables: {
      tags: Array.from(tags).sort(),
    },
    fetchPolicy: 'cache-and-network',
    errorPolicy: 'all',
  });

  const options = [];
  if (data && data.CollectionsGroups) {
    data.CollectionsGroups.forEach(collectionsGroup => {
      options.push({
        label: collectionsGroup.title,
        id: collectionsGroup.id,
        href: collectionsGroup.href,
      });
    });
  } else {
    // Fallback to some hardcoded options
    options.push(
      ...defaultCollectionsTabs.map(option => ({
        label: option.title,
        id: option.tag,
        href: option.href,
      })),
    );
  }
  if (!options.find(option => option.id === selectedTab)) {
    // Ad-hoc... display based on the URL path matching collections tags.
    options.push({
      label: selectedTab ? selectedTab.charAt(0).toUpperCase() + selectedTab.slice(1) : '',
      id: selectedTab,
      href: `/collections/${selectedTab}`,
    });
  }
  return (
    <Tabs
      className="margin-bottom-20"
      selected={selectedTab}
      options={options}
      ariaLabel="Collection tabs"
      idPrefix="collections"
    />
  );
}

CollectionsTabs.propTypes = {
  selectedTab: PropTypes.string,
};

CollectionsTabs.defaultProps = {
  selectedTab: 'mine',
};
